import React from 'react';

const GalleryFilter = ({ years, activeYear, onYearChange }) => (
  <nav className="gallery-filter" aria-label="Nach Jahr filtern" data-testid="gallery-filter">
    <button
      className={`gallery-filter-tab${!activeYear ? ' gallery-filter-tab--active' : ''}`}
      type="button"
      onClick={() => onYearChange(null)}
      data-testid="gallery-filter-alle"
    >
      Alle
    </button>
    {years.map((year) => (
      <button
        key={year}
        className={`gallery-filter-tab${activeYear === year ? ' gallery-filter-tab--active' : ''}`}
        type="button"
        onClick={() => onYearChange(year)}
        data-testid={`gallery-filter-${year}`}
      >
        {year}
      </button>
    ))}
  </nav>
);

export default GalleryFilter;
